import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppletContainerModel } from 'blg-akaun-ts-lib';
import { SubSink } from 'subsink2';
// import { PersonalizationActions } from '../../state-controllers/application-controller/store/actions';
// import { PersonalizationSelectors } from '../../state-controllers/application-controller/store/selectors';
// import { SessionActions } from '../../state-controllers/session-controller/store/actions';
// import { SessionSelectors } from '../../state-controllers/session-controller/store/selectors';
// import { SessionStates } from '../../state-controllers/session-controller/store/states';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})

export class SettingsComponent implements OnInit, OnDestroy {

  @Input() routes;
  @Input() translatedMenu;

  private subs = new SubSink();
  // readonly appletSettings$ = this.store.select(SessionSelectors.selectAppletSettings);
  // readonly logoBgColor$ = this.appStore.select(PersonalizationSelectors.selectLogoBgColor);
  // readonly sidebarBgColor$ = this.appStore.select(PersonalizationSelectors.selectSidebarBgColor);
  // readonly errorLog$ = this.viewColFacade.collectErrorLog();

  constructor(
    // private readonly store: Store<SessionStates>
    ) {}

  ngOnInit() {
  }

  generateTxtFile(text) {
    let textFile = null;
    const data = new Blob([text], {type: 'text/plain;charset=utf-8'});
    if (textFile !== null) {
      window.URL.revokeObjectURL(textFile);
    };
    textFile = window.URL.createObjectURL(data);
    return textFile;
  }

  onLog(e) {
    // this.subs.sink = this.viewColFacade.collectErrorLog().subscribe(a => {
    //   e.style.display = 'inline';
    //   (<any>e).href = this.generateTxtFile(JSON.stringify(a));
    // });
  }

  onSaveDefault(applet: AppletContainerModel) {
    // this.store.dispatch(SessionActions.updateAppletSettingsInit({applet}));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}


